// 64 × 64 = 4,096 combinations.

export const ADJECTIVES = [
  'ясный','тёмный','живой','тихий','нежный','сильный','слабый','лёгкий',
  'тяжёлый','высокий','низкий','широкий','узкий','быстрый','медленный','большой',
  'бледный','чёрный','белый','красный','синий','зелёный','жёлтый','золотой',
  'серебряный','медный','янтарный','пурпурный','коралловый','слоновый','пепельный','алый',
  'холодный','тёплый','свежий','сухой','влажный','мягкий','твёрдый','острый',
  'гладкий','шершавый','яркий','матовый','чистый','вольный','древний','новый',
  'первый','последний','глубокий','тонкий','толстый','короткий','длинный','круглый',
  'квадратный','стройный','великий','малый','благородный','дикий','далёкий','близкий',
]

export const NOUNS = [
  'луна','солнце','звезда','небо','облако','ветер','дождь','снег',
  'буря','радуга','туман','роса','иней','гроза','заря','закат',
  'море','река','озеро','лес','гора','долина','камень','песок',
  'пещера','водопад','холм','равнина','остров','утёс','берег','луг',
  'роза','лилия','ирис','гвоздика','фиалка','мак','жасмин','лаванда',
  'дуб','клён','ива','кедр','сосна','бук','липа','вяз',
  'птица','воробей','ласточка','соловей','орёл','сокол','ворон','цапля',
  'лебедь','волк','лис','заяц','олень','медведь','рысь','белка',
]
